export const changeLanguage = ()=>{
    return (dispatch, getState, getFirebase) => {
        const firebase = getFirebase();

        const {universal} = getState(); 
        let languageCode = 'en';
        if(universal.language === 'ko') {
            languageCode = 'ko';
        }
        firebase.auth().languageCode = languageCode;
        dispatch({
            type : 'CHANGE_LAN'
        })
    }
}


export const signUpShow = ()=> {
    return {
        type : 'SIGNUP_SHOW'
    }
}

export const logOut = () => {
    return (dispatch, getState, getFirebase)=> {
        const auth = getFirebase().auth();
        const user = auth.currentUser;
        if(user){
            auth.signOut();
        }
    }
}


// WEBPACK FOOTER //
// ./src/components/Navigation/actions/navigationActions.js